import React from "react";
import { Link } from 'react-router-dom'
import SearchIcon from "mdi-react/SearchIcon"
import { withMyDataContext } from "../context/DataProvider";
import Aux from "../utils/AuxFunctions";
import Fire from "../config/Fire";
import Colors from "../utils/Colors";
import Loader from "../utils/Utilities/Loader";
import QueryString from "query-string"
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";

const LIMIT = 30

class Search extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            searchData: [],
            searchText: "",
            searchType: "user",
            lastVisible: null,
            finished: false,
            loading: false,
            isLoadingTags: false,
            currentTab: 0,

            noUsers: false,
            noHashtags: false,
        }
    }

    componentDidMount() {
        this.init()
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search) {
            this.init()
        }
    }

    init = () => {
        try {
            if (this.props.location.search) {
                const urlParams = QueryString.parse(this.props.location.search);
                //this.setState({searchType:"user"})
                var text = ""
                var type = ""
                if (urlParams?.q) {
                    text = urlParams.q
                    this.setState({ searchText: urlParams.q })
                }
                if (urlParams?.type) {
                    type = urlParams?.type
                    /*  useType= true
                     if(urlParams.type === "hashtag"){
                         this.setState({searchType:"hashtag"})
                     }else{
                         this.setState({searchType:"user"})
                     } */
                }
                this.setState({ searchText: text, searchType: type || "user" })
                this.onSearch(text, type)
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    onSearch = async (text, type,) => {
        if (this.state.loading)
            return
        try {
            if (this.state.searchText || text) {
                let data = []

                this.setState({ loading: true, usersData: [], noHashtags: false, noUsers: false })
                if (type === "hashtag") {
                    data = await Fire.shared.getSearchHashtag(this.state.searchText.toLowerCase() || text.toLowerCase(), LIMIT)
                    if (data) {
                        this.setState({ searchData: [...data], });
                    } else {
                        this.setState({ noHashtags: true });
                    }
                } else {
                    data = await Fire.shared.getSearchUser(this.state.searchText.toLowerCase() || text.toLowerCase(), LIMIT)
                    if (data) {
                        this.setState({ searchData: [...data], });
                    } else {
                        this.setState({ noUsers: true });
                    }
                }
            } else {
                this.setState({ searchData: [] })
            }
            this.setState({ loading: false })
        } catch (error) {
            this.setState({ loading: false })
            Aux.handleError(error)
        }
    }

    renderProfile = (props) => {
        return (
            <div className="selectable-hover" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "15px 20px", overflow: "hidden" }}
                onClick={() => this.goToUser(props.user)}>
                <div style={{ display: "flex", alignItems: "center", overflow: "hidden" }}>
                    {Aux.showAvatar(40, props.user.avatar, props.user.username || "Unknown")}
                    <div style={{ marginLeft: 10, display: "flex", flexDirection: "column", overflow: "hidden", justifyContent: "center" }}>
                        <span style={{ fontSize: 15, textOverflow: "ellipsis", overflow: "hidden", color: Colors.darkText }}>{props.user.username}</span>
                        {props.user.coinsSpent > 0 ?
                            <span style={{ fontSize: 13, textOverflow: "ellipsis", overflow: "hidden", color: Colors.softText, }}>{props.user.coinsSpent || 0}$</span>
                            : null}
                    </div>
                </div>

            </div>
        )
    }

    userRender = (props) => {
        return (
            <Link className="selectable-hover" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 20px", textDecoration: "none", overflow: "hidden" }} to={`/user/${props.user.username}`} >
                <div style={{ display: "flex", alignItems: "center", marginRight: 20, overflow: "hidden" }} /* onClick={() =>{this.goToProfile(props.user.username)}} */>
                    {Aux.showAvatar(50, props.user.avatar, props.user.username || "Unknown")}
                    <span className="user-text-underline" style={{ marginLeft: 10, fontWeight: "500", fontSize: 14, color: Colors.middleText, textOverflow: "ellipsis", overflow: "hidden" }}>
                        {props.user.username || "Unknown"}
                    </span>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ fontWeight: "bold", fontSize: 14, color: Colors.darkText }}>
                        {props.user.coinsSpent || 0}$
                    </span>
                </div>
            </Link>
        )
    }

    hashtagRender = (props) => {
        return (
            <Link className="selectable-hover" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 20px", textDecoration: "none", overflow: "hidden" }} to={`/user/${props.tag.hashtag}`} >
                <div style={{ display: "flex", alignItems: "center", marginRight: 20, overflow: "hidden" }} /* onClick={() =>{this.goToProfile(props.user.username)}} */>
                    <span className="user-text-underline" style={{ marginLeft: 10, fontWeight: "bold", color: Colors.middleText, textOverflow: "ellipsis", overflow: "hidden" }}>
                        #{props.tag.hashtag || "..."}
                    </span>

                    {/* <span style={{marginLeft:5, fontSize:15, textOverflow:"ellipsis", overflow:"hidden", color: Colors.softText, }}>({props.tag.coins || 0}$)</span>     */}

                </div>

                {props.tag.coins > 0 ?
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span style={{ fontWeight: "bold", fontSize: 14, color: Colors.darkText }}>
                            {props.tag.coins || 0}$
                    </span>
                    </div> : null}
            </Link>
        )
    }

    goToProfile = (profile) => {
        try {
            this.props.history.push("/user/" + profile)
        } catch (error) {
            Aux.handleError(error)
        }
    }

    selectedTab = {
        backgroundColor: "#CCECFF",
        color: Colors.mainColor,
        borderRadius: 10,
        padding: "3px 20px",
        fontWeight: "bold",

    };

    unselectedTab = {
        backgroundColor: "#eee",
        color: Colors.middleText,
        borderRadius: 10,
        padding: "3px 20px",
        fontWeight: "500",
    }

    onEnterPressed = (e) => {
        try{
            if (e.key === 'Enter') {
                this.onSearch(this.state.searchText, this.state.searchType)
            }
        }catch(error){
            Aux.handleError(error)
        }
    }

    render() {
        return (
            <div style={{ width: "100%", }}>
                <section className="container">
                    <div style={{ display: "flex", alignItems: "center", margin: "0 20px", }}>
                        <TextInputMaterial type="text" placeholder="Search..."
                            //style={{ padding: "7px 20px", marginBottom: 0 }}
                            style={{width:"100%"}}
                            onKeyDown={this.onEnterPressed}
                            value={this.state.searchText}
                            onChange={(e) => {
                                this.setState({ searchText: e.target.value })
                            }}/>
                        <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }} onClick={() => this.onSearch(this.state.searchText, this.state.searchType)}>
                            <SearchIcon size={30} className="search-icon" style={{ padding: 4, }} />
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-around", marginTop: 15 }}>
                        <span className={"reversed-button-hover"} onClick={() => { this.setState({ searchType: "user" }); this.onSearch(this.state.searchText, "user", true) }}
                            style={this.state.searchType !== "hashtag" ? this.selectedTab : this.unselectedTab}>
                            User
                    </span>
                        <span className={"reversed-button-hover"} onClick={() => { this.setState({ searchType: "hashtag" }); this.onSearch(this.state.searchText, "hashtag", true) }}
                            style={this.state.searchType === "hashtag" ? this.selectedTab : this.unselectedTab}>
                            Hashtag
                    </span>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        {this.state.loading ? <Loader></Loader>
                            :
                            this.state.noHashtags ?
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <span>No hashtags found</span>
                                </div>
                                : this.state.noUsers ?
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <span>No users found</span>
                                    </div> :
                                    this.state.searchData.length <= 0 ?
                                        <div style={{ display: "flex", justifyContent: "center", }}>
                                            <span>Search for a user or hashtag</span>
                                        </div> :
                                        this.state.searchData.map((item, i) => (
                                            <div key={i} >
                                                {this.state.searchType === "user" ? <this.userRender user={item} /> : <this.hashtagRender tag={item} />}
                                            </div>
                                        ))}
                    </div>
                </section>

            </div>
        );
    };


}
export default withMyDataContext(Search);